import { ResponsiveIframeModule } from '@/src/types/common/content';
import { EnumModuleType } from '@/src/types/common/module';

type Params = {
  pc: ResponsiveIframeModule;
  tablet: ResponsiveIframeModule;
  mobile: ResponsiveIframeModule;
  moduleType: EnumModuleType;
};

class IframeStrategy {
  assign(obj: any, target: any) {
    Object.assign(obj, target);
  }

  invokeStrategy({ pc, tablet, mobile }: Params) {
    const _tablet = tablet;
    const _mobile = mobile;
    const {
      linkModule, // visible,
      moduleStyle,
    } = pc;
    this.assign(_tablet, {
      //  visible,
      linkModule,
      moduleStyle: {
        ...mobile.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    this.assign(_mobile, {
      // visible,
      linkModule,
      moduleStyle: {
        ...mobile.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    return {
      pc,
      tablet: _tablet,
      mobile: _mobile,
    };
  }
}

export default new IframeStrategy();
